import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function RoofingSpecialistsHero() {
  return <section data-section-id="56472" id="drömmen-om-ett-badrum" className="dark bg-black text-foreground relative w-full min-h-[90vh] flex items-center justify-center overflow-hidden">
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center">
        <h1 className="font-default font-semibold text-white text-5xl md:text-7xl lg:text-[80px] leading-[1.1] tracking-tighter mb-10 drop-shadow-2xl max-w-5xl uppercase">
          Exklusiva badrum i värmland
        </h1>

        <p className="text-white/80 text-base sm:text-xl max-w-2xl mx-auto text-center leading-relaxed mb-10">
          Vi hjälper dig med exklusiv badrumsrenovering i Värmland, från första idé och materialval till samordnad totalentreprenad och färdigt badrum.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-6 w-full sm:w-auto">
          <Button asChild className="bg-primary hover:bg-primary/90 text-white rounded-md h-auto py-5 px-10 text-lg font-semibold shadow-xl transition-all hover:scale-105 hover:shadow-primary/20 border-none">
            <Link to="/QuoteRequestPage">Begär offert</Link>
          </Button>

          <Button asChild variant="outline" className="bg-white/5 border-2 border-white/30 text-white hover:bg-white/10 hover:text-white hover:border-white rounded-md h-auto py-5 px-10 text-lg font-semibold transition-all hover:scale-105 backdrop-blur-md">
            <Link to="/InspirationPage">Se inspiration</Link>
          </Button>
        </div>
      </div>
    </section>;
}